import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemAuditingRoute: InvariantJiraRoute = {
	name: 'global-settings-system-auditing',
	path: '/auditing/:page',
};
